import React, {useState, useEffect} from "react";
import "./CompanyList.css";
import {useDispatch, useSelector} from "react-redux";
import {Accordion, Button, Col, Row} from "react-bootstrap";
import CompanyUsers from "./CompanyUsers";
// import CompanyLocations from "./CompanyLocations";
import {translate} from "./Language/Translate";
import Auth from "../helpers/auth";
import CompanyEdit from "../newForms2/companies/CompanyEdit";
import {deleteCompanyFromAPI} from "../actions/companies";
import {fetchCompanyFromAPI} from "../actions/currentCompany";
import Spinner from "./Spinner";
import {isInDevelopment} from "../config";
import UserDeveloperInfo from "./UserDeveloperInfo";

const CompanyDetails = ({companyId, backFunc}) => {
  const [showEditForm, setShowEditForm] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const currentUser = useSelector(st => st.currentUser);
  const userStatus = currentUser?.userStatus || "";
  const currentCompany = useSelector(st => st.currentCompany);
  const dispatch = useDispatch();
  const isMainAdmin = Auth.isMainAdmin(currentUser.userStatus);
  const showUsers = isMainAdmin || Auth.isCorrectCompany(currentUser, companyId);
  console.log({currentCompany});

  // console.log("###############################", {isMainAdmin, currentUser, coId: currentCompany.id, showUsers});

  useEffect(() => {
    const fetch = async () => {
      dispatch(fetchCompanyFromAPI(companyId));
      setIsLoading(false);
    };
    if (isLoading) fetch();
  }, [isLoading, companyId, dispatch, userStatus]);

  if (isLoading) return <Spinner />;

  const handleDelete = async () => {
    dispatch(deleteCompanyFromAPI(currentCompany.id));
    setConfirmDelete(false);
    backFunc();
  };
  // console.log(" inside CompanyDetails", companyId, currentCompany);
  const ConfirmDelete = () => {
    return (
      <div className="m-3 p-3" style={{border: "1px solid grey", borderRadius: "5px"}}>
        <h6 className="text-danger">Sind Sie sicher, daß sie diesen Schule löschen möchten?</h6>
        <Row>
          <Col>
            <Button block className="btn-danger" onClick={handleDelete}>
              Ja
            </Button>
          </Col>
          <Col>
            <Button block className="btn-secondary" onClick={() => setConfirmDelete(false)}>
              Nein
            </Button>
          </Col>
        </Row>
      </div>
    );
  };
  // console.log({companyId, backFunc, currentCompany});
  const Details = () => {
    const {name, schoolnumber, address, homepage, land} = currentCompany;
    const txt = `${schoolnumber ? `${`Schulnummer: ${schoolnumber}, `}` : ""} ${address} (${land}), ${homepage ? homepage : ""}`;
    // const x = `${schoolnumber ? `${`Schulnummer: ${schoolnumber}`:""}`}, ${address}, `}

    return (
      <div className="m-2 p-3" style={{border: "1px solid grey", borderRadius: "5px"}}>
        {isInDevelopment && <UserDeveloperInfo user={currentUser} companyId={companyId} />}
        <h5>{name}</h5>
        <h6>{txt}</h6>

        <Row>
          {Auth.isSubAdmin(userStatus, currentCompany.id) && (
            <Col>
              <button className="btn btn-primary col-12" onClick={() => setShowEditForm(true)}>
                {translate("Edit Company")}
              </button>
            </Col>
          )}
          {Auth.isSubAdmin(userStatus, currentCompany.id) && (
            <Col>
              <button
                className="btn btn-danger mx-1 col-12"
                onClick={() => {
                  setConfirmDelete(true);
                }}
              >
                {translate("Delete Company")}
              </button>
            </Col>
          )}
          <Col>
            <button className="btn btn-secondary col-12" onClick={backFunc}>
              Zurück
            </button>
          </Col>
        </Row>
        {/* <h6 className="my-3">Benutzer</h6> */}
        {showUsers && (
          <Accordion className="my-2">
            {/* <CompanyLocations eventKey="0" /> */}
            <CompanyUsers eventKey="1" />
          </Accordion>
        )}
        {confirmDelete && <ConfirmDelete />}
      </div>
    );
  };
  // console.log(currentCompany, currentUser)
  return (
    <div>
      {showEditForm && <CompanyEdit backFunc={() => setShowEditForm(false)} />}
      {!showEditForm && <Details />}
    </div>
  );
};
export default CompanyDetails;
